"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
exports.__esModule = true;
exports.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES = 3;
